import { gql } from '@apollo/client'

export const GET_CUSTOMER_CARTS = gql`
  query GET_CUSTOMER_CARTS($customerId: Int!) {
    getCustomerCarts(customerId: $customerId) {
      id
      name
      isActive
      isModified
      updatedAt
      itemCount
    }
  }
`

// CartItem selection mirrored from the proven `CartItemFields` fragment in
// vilmers-b2b-portal (src/lib/furnisystems-sdk/modules/cart/index.ts), with
// `id` and `type` added on `product_container` so the read-only renderer can
// branch on container.type and link to /products/:id like the order detail view.
export const GET_CART_BY_ID = gql`
  query GET_CART_BY_ID($cartId: Int!) {
    getCartById(cartId: $cartId) {
      id
      name
      isActive
      isModified
      customerId
      createdAt
      updatedAt
      items {
        id
        quantity
        price
        volume
        reference
        product_type
        advanced_product_type
        fabric_code
        fabric_group_name
        fabric_color_name
        fabric {
          id
        }
        fabric_group {
          id
        }
        selected_sofa_combinations
        components_by_module
        cartId
        productContainerId
        createdAt
        updatedAt
        product_container {
          id
          type
          single_product {
            images {
              src
              src_xs
              src_thumbnail
            }
            product_profiles {
              name
              language
            }
          }
          advanced_product {
            id
            images {
              src
              src_xs
              src_thumbnail
            }
            advanced_product_profiles {
              name
              language
            }
            dimensions {
              width
              height
              length
              seat_height
              seat_width
              seat_depth
              headboard_height
              headboard_width
              mattress_width
              mattress_length
              table_extended_lengh
              table_top_thickness
              table_leg_width
              shade_height
              shade_radius
            }
          }
        }
        additional_components {
          id
          code
          additional_component_profiles {
            name
            material_name
            language
          }
          image {
            src
            src_thumbnail
          }
          color {
            id
            hex
            background
          }
          additional_component_group {
            id
            code
            additional_component_group_profiles {
              name
              language
            }
          }
          dimensions {
            width
            height
            length
          }
        }
        cartItemFabrics {
          id
          fabric_code
          fabric_color_name
          fabric_group_name
          fabric {
            id
            code
            color_name
            image {
              src
              src_thumbnail
            }
          }
          fabric_group {
            id
            code
            type
            fabric_group_profiles {
              language
              name
            }
          }
          combination_option {
            id
            fabricCombinationOptionProfiles {
              language
              name
            }
          }
        }
        sofa_forms {
          id
          name
          code
        }
        fabricCombination {
          id
          image {
            src
            src_xs
            src_thumbnail
          }
        }
      }
    }
  }
`
